import { createMutationHelper } from '@utils/swr'
import { type CampaignAdminConfirmRegularGiveawaysRequest } from '../types/apiRequest'
import { type FortuneApis } from '../types/apis'

const { useMutation } = createMutationHelper<FortuneApis['post']['confirmRegularGiveaways'], never, CampaignAdminConfirmRegularGiveawaysRequest>({
  client: 'fastpassAdmin',
  key: '/campaigns',
  fetcher: (_url, { arg, client }) => {
    if (!arg.code) {
      return Promise.reject(new Error('Campaign code is required'))
    }
    return client.post(`/campaigns/${arg.code}/admin/payment-transactions/${arg.payment_transaction_id}/regular-giveaways-confirmation`)
  },
})

export const useApiMutationAdminConfirmRegularGiveaways = useMutation
